document.addEventListener('DOMContentLoaded', function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nums = document.querySelectorAll('.trust-item .num[data-count]');
  if (!nums.length) return;

  function animate(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    var suffix = el.getAttribute('data-suffix') || '';
    if (reduce || isNaN(target)) {
      el.textContent = target + suffix;
      return;
    }
    var start = null;
    var duration = 1100;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var val = Math.floor(eased * target);
      el.textContent = val + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { obs.observe(n); });
  } else {
    nums.forEach(animate);
  }
});


// ---------- Sell Us Your Stuff: photo upload + submission ----------
document.addEventListener('DOMContentLoaded', function () {
  var input = document.getElementById('cardPhotoInput');
  if (!input) return; // only present on sell.html

  var form = document.getElementById('cardForm');
  var preview = document.getElementById('previewImg');
  var dropContent = document.getElementById('dropZoneContent');
  var dropZone = document.getElementById('dropZone');
  var status = document.getElementById('analyzeStatus');
  var description = document.getElementById('cardDescription');
  var category = document.getElementById('cardCategory');
  var autoFilledTag = document.getElementById('autoFilledTag');
  var emailField = document.getElementById('contactEmail');
  var phoneField = document.getElementById('contactPhone');
  var contactError = document.getElementById('contactError');
  var submitBtn = document.getElementById('submitBtn');
  var modal = document.getElementById('submitModal');
  var modalDescription = document.getElementById('modalDescription');
  var modalCondition = document.getElementById('modalCondition');
  var closeModalBtn = document.getElementById('closeModal');

  var lastGrade = ''; // holds the simulated condition line for the confirmation modal

  // No prices anywhere in this flow \u2014 identification/description only.
  var DEMO_RESULTS = {
    "Basketball": [
      { desc: "Looks like a modern rookie-era chrome parallel. Sharp corners, strong centering, no visible surface wear.", grade: "Near Mint" },
      { desc: "Appears to be a rookie autograph insert. Light edge wear on one corner, centering slightly off.", grade: "Excellent" }
    ],
    "Football": [
      { desc: "Appears to be a rookie patch autograph. Clean surface, tight corners, well-centered.", grade: "Near Mint" },
      { desc: "Looks like a base rookie parallel. Minor whitening on one back corner, otherwise clean.", grade: "Excellent" }
    ],
    "Baseball": [
      { desc: "Appears to be a vintage-style rookie reprint. Some edge softness consistent with age, clean surface.", grade: "Excellent" },
      { desc: "Looks like a modern chrome-style refractor rookie. Sharp corners, excellent centering.", grade: "Near Mint" }
    ],
    "Hockey": [
      { desc: "Appears to be a Young Guns\u2013style rookie. Clean surface, strong corners, centered well.", grade: "Near Mint" }
    ],
    "Pok\u00e9mon": [
      { desc: "Looks like a holo rare. Light scratching visible on the surface under light, sharp corners.", grade: "Excellent" },
      { desc: "Appears to be an alt art rare. Pack-fresh surface, excellent centering, no whitening.", grade: "Near Mint" }
    ],
    "One Piece": [
      { desc: "Looks like a leader parallel. Clean surface, minor corner softness.", grade: "Excellent" }
    ],
    "Lorcana": [
      { desc: "Appears to be an Enchanted rare. Pack-fresh, sharp corners, excellent centering.", grade: "Near Mint" }
    ]
  };

  function pickResult(cat) {
    var pool = DEMO_RESULTS[cat] || DEMO_RESULTS["Basketball"];
    return pool[Math.floor(Math.random() * pool.length)];
  }

  function handleFile(file) {
    if (!file || file.type.indexOf('image/') !== 0) return;
    var reader = new FileReader();
    reader.onload = function (e) {
      preview.src = e.target.result;
      preview.style.display = 'block';
      if (dropContent) dropContent.style.display = 'none';
      runAnalysis();
    };
    reader.readAsDataURL(file);
  }

  function runAnalysis() {
    var steps = ["Reading photo\u2026", "Identifying card details\u2026", "Checking corners, edges & centering\u2026"];
    status.style.display = 'block';
    var i = 0;
    function next() {
      if (i < steps.length) {
        status.textContent = steps[i];
        i++;
        setTimeout(next, 500);
      } else {
        finishAnalysis();
      }
    }
    next();
  }

  function finishAnalysis() {
    var cat = category.value;
    var result = pickResult(cat);
    description.value = result.desc;
    lastGrade = result.grade;
    status.textContent = 'Apparent condition: ' + result.grade + ' (simulated \u2014 no value shown)';
    autoFilledTag.style.display = 'inline';
  }

  input.addEventListener('change', function () {
    if (input.files && input.files[0]) handleFile(input.files[0]);
  });
  dropZone.addEventListener('dragover', function (e) { e.preventDefault(); dropZone.style.borderColor = '#c9a227'; });
  dropZone.addEventListener('dragleave', function () { dropZone.style.borderColor = ''; });
  dropZone.addEventListener('drop', function (e) {
    e.preventDefault();
    dropZone.style.borderColor = '';
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      input.files = e.dataTransfer.files;
      handleFile(e.dataTransfer.files[0]);
    }
  });

  // --- Contact requirement: email OR phone, at least one ---
  function hasValidContact() {
    var email = emailField.value.trim();
    var phone = phoneField.value.trim();
    var emailOk = email.length > 3 && email.indexOf('@') > 0;
    var phoneDigits = phone.replace(/\D/g, '');
    var phoneOk = phoneDigits.length >= 7;
    return emailOk || phoneOk;
  }
  function clearContactError() {
    contactError.style.display = 'none';
  }
  emailField.addEventListener('input', clearContactError);
  phoneField.addEventListener('input', clearContactError);

  // --- Submit: validate, then send to Netlify Forms (or fail gracefully in local preview) ---
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!input.files || !input.files[0]) {
      dropZone.style.borderColor = '#b3212f';
      dropZone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!hasValidContact()) {
      contactError.style.display = 'block';
      emailField.focus();
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting\u2026';

    var formData = new FormData(form);
    fetch(form.getAttribute('action') || '/', { method: 'POST', body: formData })
      .then(function () { showConfirmation(); })
      .catch(function () {
        // Expected in local preview / before this site is deployed to Netlify.
        // Once live on Netlify, this POST is what triggers the email notification.
        showConfirmation();
      });
  });

  function showConfirmation() {
    modalDescription.textContent = description.value || 'No details captured \u2014 try re-uploading the photo.';
    modalCondition.textContent = lastGrade ? ('Apparent condition: ' + lastGrade + ' (simulated)') : '';
    modal.style.display = 'flex';
    submitBtn.disabled = false;
    submitBtn.textContent = 'Submit Photos for Review';
  }

  closeModalBtn.addEventListener('click', function () { modal.style.display = 'none'; });
  modal.addEventListener('click', function (e) { if (e.target === modal) modal.style.display = 'none'; });
});

// ---------- 2026 redesign: mobile navigation, scroll reveals, lightweight depth ----------
document.addEventListener('DOMContentLoaded', function () {
  var nav = document.querySelector('.nav');
  var links = document.querySelector('nav.links');
  if (nav && links && !document.querySelector('.mobile-menu-btn')) {
    var btn = document.createElement('button');
    btn.className = 'mobile-menu-btn';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Open navigation');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '&#9776;';
    nav.appendChild(btn);
    btn.addEventListener('click', function () {
      var open = links.classList.toggle('mobile-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.innerHTML = open ? '&#10005;' : '&#9776;';
    });
    links.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        links.classList.remove('mobile-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.innerHTML = '&#9776;';
      });
    });
  }

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.section-head, .cat-tile, .card-tile, .review-card, .link-tile, .estimator-card, .sell-steps li, .contact-list li');
    document.documentElement.classList.add('reveal-ready');
    targets.forEach(function (el) { el.setAttribute('data-reveal', ''); });
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    targets.forEach(function (el) { revealObserver.observe(el); });
  }
});


// ---------- Final cross-page Shop mega-menu reliability ----------
document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(min-width:981px)').matches) return;
  document.querySelectorAll('nav.links > .navitem').forEach(function (item) {
    var menu = item.querySelector(':scope > .megamenu');
    if (!menu) return;
    var timer = null;
    function openMenu() {
      if (timer) { clearTimeout(timer); timer = null; }
      item.classList.add('shop-open');
    }
    function closeSoon() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { item.classList.remove('shop-open'); }, 350);
    }
    item.addEventListener('mouseenter', openMenu);
    menu.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', closeSoon);
    menu.addEventListener('mouseleave', closeSoon);
    item.addEventListener('focusin', openMenu);
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) closeSoon();
    });
  });
});
